import Header from '../../common/Header/Header'
// import img from '../../../Assets/Images/hands.jpg'
import { useTranslation } from 'react-i18next'
import './Three.css'
function Three(){
  const { t } = useTranslation();
  return(
    <div className="three-container container">
      <Header header={t('improveYourHealth')} desc={t('improveYourHealthDesc')}/>

      <div className="three-content content">
        <div className='information'>
          <div className="info">
            <h2 className='h-after-effect'>{t('whoWeAre')}</h2>
            <div>   
              <p>{t('whoWeAreDesc1')}</p>
              <br />
              <p>{t('whoWeAreDesc2')}</p>
            </div>
          </div>
          <div className="image">
            {/* <img src={img} alt="imagee" /> */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Three